import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { JobCard } from "@/components/JobCard";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import api from "@/lib/api";
import { Bookmark } from "@phosphor-icons/react";

export default function SavedJobs() {
  const [jobs, setJobs] = useState([]);
  const [savedIds, setSavedIds] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/me/saved-jobs")
      .then(({ data }) => { setJobs(data.jobs); setSavedIds(data.saved_ids); })
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const onToggleSaved = (id, isSaved) => {
    if (!isSaved) {
      setJobs((prev) => prev.filter((j) => j.id !== id));
      setSavedIds((prev) => prev.filter((x) => x !== id));
    }
  };

  return (
    <div className="App bg-secondary/40">
      <Navbar />
      <div className="mx-auto max-w-4xl px-4 py-10 md:px-8">
        <h1 className="font-heading text-3xl font-bold tracking-tight" data-testid="saved-jobs-heading">Saved Jobs</h1>
        <p className="mt-1 text-sm text-muted-foreground">{jobs.length} saved vacanc{jobs.length === 1 ? "y" : "ies"}</p>

        <div className="mt-6 space-y-3">
          {loading && Array.from({ length: 3 }).map((_, i) => <Skeleton key={i} className="h-28 w-full rounded-xl" />)}

          {!loading && jobs.length === 0 && (
            <div className="rounded-2xl border border-dashed border-border bg-card p-16 text-center" data-testid="no-saved-jobs">
              <Bookmark size={40} className="mx-auto text-muted-foreground" />
              <p className="mt-4 font-semibold">No saved jobs yet</p>
              <p className="mt-1 text-sm text-muted-foreground">Tap the bookmark on any job to save it for later.</p>
              <Link to="/jobs"><Button className="mt-5 rounded-full">Browse jobs</Button></Link>
            </div>
          )}

          {!loading && jobs.map((job, i) => (
            <JobCard key={job.id} job={job} index={i} saved={savedIds.includes(job.id)} onToggleSaved={onToggleSaved} />
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
